import React from 'react';
import PropTypes from 'prop-types';
import Swiper, { SwiperArrowType, SwiperType } from '@deporvillage/swiper-component';
import ProductItem, { ProductItemWrapper, ProductItemType as Type, ProductItemContext } from '@deporvillage/product-item-component';
import { Config } from '@deporvillage/utils-library-component';

import styles from './ProductSlider.module.scss';

const getSwiperType = (type) => {
    switch (type) {
        case Type.Alternative:
            return SwiperType.Alternative;
        default:
            return SwiperType.Default;
    };
};

const ProductSlider = ({ items, type = Type.Default, title, anchor, query, onClick, breakpoints, isArrowHidden, finite }) => {

    const { isMobile } = React.useContext(Config);

    const redirect = (url) => {
        onClick && onClick();
        /* eslint-disable-next-line no-undef */
        window.location.href = url;
    };

    const getItemLink = (url) => {
        const params = (query || []).reduce((p, { key, value }) => (
            [...p, `${key}=${value}`]
        ), []).join('&');
        return `${url}${!params || /\?/.test(url) ? '' : '?'}${params}`;
    };

    return items && items.length ? (
        <div className={`${styles['product-slider-component']} ${styles[type]}`}>
            {
                title && (
                    <div className={styles['product-slider-title']}>{title}</div>
                )
            }
            <div className={`${styles['product-slider-swiper-wrapper']} product-slider-swiper-wrapper`}>
                <Swiper
                    breakpoints={breakpoints}
                    arrows={isArrowHidden ? SwiperArrowType.None : (isMobile ? SwiperArrowType.None : SwiperArrowType.Out)}
                    type={getSwiperType(type)}
                    loop={!finite && type === Type.Default}
                >
                    {items.map((item, id) => (
                        <div key={id} className={styles['product-slider-wrapper']}>
                            <ProductItemContext.Provider value={{ type }}>
                                <ProductItemWrapper>
                                    {anchor ? (
                                        <a className={styles['product-item-wrapper']} rel='nofollow'
                                            href={getItemLink(item.link || item.url)} title={item.title} onClick={() => onClick && onClick()}>
                                            <ProductItem item={item} />
                                        </a>
                                    ) : (
                                        <span className={styles['product-item-wrapper']} onClick={() => redirect(getItemLink(item.link || item.url))}>
                                            <ProductItem item={item} />
                                        </span>
                                    )}
                                </ProductItemWrapper>
                            </ProductItemContext.Provider>
                        </div>
                    ))}
                </Swiper>
            </div>
        </div>
    ) : null;
};

ProductSlider.propTypes = {
    type: PropTypes.oneOf([
        Type.Default,
        Type.Alternative,
    ]),
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    anchor: PropTypes.bool,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            gallery: PropTypes.shape({
                default: PropTypes.number,
                images: PropTypes.arrayOf(PropTypes.string),
            }),
            url: PropTypes.string,
            defaultVariant: PropTypes.shape({
                price: PropTypes.shape({
                    pvp: PropTypes.number,
                    price: PropTypes.number,
                    currency: PropTypes.string,
                }),
            }),
            discountTag: PropTypes.shape({
                show: PropTypes.bool,
            }),
        })
    ),
    onClick: PropTypes.func,
    breakpoints: PropTypes.object,
    isArrowHidden: PropTypes.bool,
    finite: PropTypes.bool,
    query: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string,
        })
    ),
};

export default ProductSlider;
export { Type as ProductSliderType };
